import { Host, h } from "@stencil/core";
import { toString, clone } from "../../utils/utils";
import { getFormConstraints } from "../../utils/FormDefinition";
export class ApieFormSelectDefinition {
    constructor() {
        this.instantiated = false;
        this.name = undefined;
        this.label = null;
        this.definitionIdList = undefined;
        this.prototyped = false;
        this.status = 'idle';
    }
    connectedCallback() {
        this.instantiated = true;
    }
    disconnectedCallback() {
        this.instantiated = false;
    }
    async getDefinition() {
        const newValue = this.definitionIdList;
        this.status = 'retrieving child metadata';
        await new Promise((resolve, reject) => {
            const id = setInterval(async () => {
                if (!this.instantiated || this.definitionIdList !== newValue) {
                    clearInterval(id);
                    reject(new Error('definitionId changed or component destroyed'));
                }
                for (let definitionId of this.definitionIdList) {
                    const name = toString(definitionId.value);
                    const definition = document.getElementById(name);
                    if (!definition) {
                        if (definitionId.definition) {
                            continue;
                        }
                        this.status = 'retrieving child metadata ' + definitionId.value;
                        return;
                    }
                    definitionId.definition = clone(await definition.getDefinition());
                    definitionId.definition.name = this.name;
                    definitionId.definition.label = this.label;
                }
                clearInterval(id);
                resolve(this.definitionIdList);
            });
        });
        this.status = 'building';
        const constraints = await getFormConstraints(this.el);
        this.status = 'built';
        return Promise.resolve({
            fieldType: 'split',
            name: this.name,
            label: this.label,
            subFields: this.definitionIdList,
            constraints,
        });
    }
    render() {
        return (h(Host, { key: 'fbb8c996eeadea51d9c41ecd6819da79f71733c3' }, h("slot", { key: '7994f269f45199182aa7af3efeb3d47706c56150' })));
    }
    static get is() { return "apie-form-select-definition"; }
    static get originalStyleUrls() {
        return {
            "$": ["apie-form-select-definition.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["apie-form-select-definition.css"]
        };
    }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "name",
                "reflect": false
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string|null",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "null"
            },
            "definitionIdList": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "Array<FormSelectOption>",
                    "resolved": "FormSelectOption[]",
                    "references": {
                        "Array": {
                            "location": "global",
                            "id": "global::Array"
                        },
                        "FormSelectOption": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::FormSelectOption"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                }
            },
            "prototyped": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "prototyped",
                "reflect": true,
                "defaultValue": "false"
            },
            "status": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "status",
                "reflect": true,
                "defaultValue": "'idle'"
            }
        };
    }
    static get methods() {
        return {
            "getDefinition": {
                "complexType": {
                    "signature": "() => Promise<FieldSplit>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "FieldSplit": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::FieldSplit"
                        }
                    },
                    "return": "Promise<FieldSplit>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=apie-form-select-definition.js.map
